<td [ngClass]="dynamicClass" class="product-section">
  <div class="product-name-column">
    <mat-checkbox
      [ngClass]="{ indent: indented }"
      class="reseller-items-table-checkbox"
      color="primary"
      [checked]="quantity > 0 || !appCanBeSelected"
      [disabled]="!!(!appCanBeSelected || item.restrictedReason)"
      type="checkbox"
      (change)="
        onCheckboxChanged($event, {
          appId: item.appId,
          currentQuantity: quantity || 0,
          allowMultiActivations: item.allowMultipleActivations
        })
      "
    ></mat-checkbox>
    <va-icon [diameter]="32" [iconName]="item.name" [iconUrl]="item.icon"></va-icon>
    <div class="product-info">
      <div *ngIf="!usesEditions || item.appId === listingBuilderProduct">
        <p
          [ngClass]="{
            'product-name-low-margin': isPending || isCancelled || item.isTrial
          }"
        >
          {{ item.name }}
        </p>
      </div>
      <div *ngIf="usesEditions && item.appId !== listingBuilderProduct">
        <p>
          {{ item.name }}
          <mat-select
            class="edition-selector"
            [(ngModel)]="currentlySelectedEdition"
            (selectionChange)="
              onEditionSelectionChange({
                edition: $event.value,
                appId: item.appId,
                currentQuantity: quantity || 0
              })
            "
            [disabled]="!appCanBeSelected"
          >
            <mat-option *ngFor="let edition of filteredEditions" [value]="edition">
              {{ edition.editionName }}
            </mat-option>
          </mat-select>
        </p>
      </div>
      <span *ngIf="item.descriptor">
        <span class="item-descriptor">{{ item.descriptor }}</span>
      </span>
      <span class="item-status-green" *ngIf="isPending">
        {{ 'APP_SELECTION.ACTIVATION_TABLE.CURRENTLY_PENDING' | translate }}
      </span>
      <span class="item-status-yellow" *ngIf="isCancelled">
        {{ 'MANAGE_ACCOUNTS.ACTIVATION_HISTORY.CANCELED' | translate }}
      </span>
    </div>
  </div>
</td>

<ng-container *ngIf="!item.restrictedReason; else restricted">
  <td [ngClass]="dynamicClass" class="quantity-section">
    <div class="quantity" *ngIf="item.allowMultipleActivations && item.parentAppId !== ''">
      <input
        matInput
        required
        type="number"
        min="0"
        max="99"
        [disabled]="item.usesCustomPricing"
        [value]="quantity"
        (input)="
          onItemQuantityChanged({
            newQuantity: $event.target.value,
            appId: item.appId,
            allowMultiActivations: item.allowMultipleActivations
          })
        "
      />
    </div>
  </td>
  <td *ngIf="!hidePricing" [ngClass]="dynamicClass" class="pricing-section last-column">
    <billing-ui-price-display
      [appPrice]="item.appPrice"
      [align]="'end'"
      [editionId]="currentlySelectedEdition?.editionId || ''"
      [priceType]="'instance'"
      [currencyCode]="item.partnerCurrency"
    ></billing-ui-price-display>
  </td>
</ng-container>

<ng-container *ngIf="removableItems">
  <td>
    <div class="clear-item" (click)="itemDeleteClicked.emit(item.appId)">
      <mat-icon>clear</mat-icon>
    </div>
  </td>
</ng-container>

<ng-template #restricted>
  <td [ngClass]="dynamicClass"></td>
  <td [ngClass]="dynamicClass" class="pricing-section">
    {{ item.restrictedReason }}
  </td>
</ng-template>
